import { fromJS, Map } from 'immutable';

import CompanyRecord from 'records/company';
import { createSymbols } from 'utils/helpers';
import { resourceReducer } from 'utils/reducerGenerator';

export const {
    FETCH_BALANCE,
    FETCH_BALANCE_FAIL,
    FETCH_BALANCE_SUCCESS,
} = createSymbols([
    'FETCH_BALANCE',
    'FETCH_BALANCE_FAIL',
    'FETCH_BALANCE_SUCCESS',
]);

export const { reducer, types } = resourceReducer(
    {
        namespace: 'COMPANY',
        transformer: CompanyRecord,
    },
    {
        [FETCH_BALANCE]: (state, { id }) => {
            const balances = state.get('balances', Map({}));

            return state.set('balances', balances.setIn([id, 'isFetching'], true));
        },
        [FETCH_BALANCE_SUCCESS]: (state, { payload }) => {
            const balances = state.get('balances', Map({}));
            const { id } = payload.data;
            const companyBalance = balances.get(id, Map({}));

            return state.setIn(['balances', id], companyBalance.set('isFetching', false).set('data', fromJS(payload.data.balance)));
        },
    }
);

export default reducer;
